// Video helpers of the exercise panel and the exercise media modal (#382).

// Only an http(s) address on YouTube or Drive may reach an iframe src: a javascript: src runs in the dashboard origin (#326)
// and any other host could show a fake form in the dashboard (#330).
const isWebUrl = (url: string) => {
  try {
    const { protocol, hostname } = new URL(url);
    return (protocol === 'http:' || protocol === 'https:') && /(^|\.)(youtube\.com|youtu\.be|drive\.google\.com)$/.test(hostname);
  } catch {
    return false;
  }
};

export const getVideoEmbedUrl = (url: string) => {
  // YouTube Shorts
  const shortsRegExp = /^.*youtube\.com\/shorts\/([^/?]+)/;
  const shortsMatch = url.match(shortsRegExp);
  if (shortsMatch && shortsMatch[1]) {
    return `https://www.youtube.com/embed/${shortsMatch[1]}`;
  }

  // YouTube
  const youtubeRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const youtubeMatch = url.match(youtubeRegExp);
  if (youtubeMatch && youtubeMatch[2].length === 11) {
    return `https://www.youtube.com/embed/${youtubeMatch[2]}`;
  }

  // Google Drive
  const driveRegExp = /^https:\/\/drive\.google\.com\/file\/d\/([^/]+)/;
  const driveMatch = url.match(driveRegExp);
  if (driveMatch) {
    return `https://drive.google.com/file/d/${driveMatch[1]}/preview`;
  }

  // Not YouTube, Shorts or Drive: return the original address only if it is http(s) on one of those hosts
  return isWebUrl(url) ? url : '';
};

export const isEmbeddableVideo = (url: string) => {
  return (
    (url.includes('youtube') || url.includes('youtu.be') || url.includes('drive.google.com')) && getVideoEmbedUrl(url) !== ''
  );
};
